export const DEFAULT_PAGE_SIZE = 10
export const FUEL_RECENT_ARTICLES_PAGE_SIZE = 3

export const DEFAULT_PAGE_START_INDEX = 0

export const FIRST_PAGE = 1

export const DYNAMIC_URLS_PAGE_LIMIT = 50
